import type {
  Vendor,
  CreateVendorRequest,
  UpdateVendorRequest,
  VendorListResponse,
} from '@techgitter/contracts';

const API_BASE_URL = '/api';

export async function getVendors(signal?: AbortSignal): Promise<Vendor[]> {
  const response = await fetch(`${API_BASE_URL}/vendors`, {
    method: 'GET',
    headers: { 'Accept': 'application/json' },
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch vendors: ${response.status} ${response.statusText}`);
  }

  const data: VendorListResponse = await response.json();
  return data.items;
}

export async function createVendor(
  payload: CreateVendorRequest,
  signal?: AbortSignal
): Promise<Vendor> {
  const response = await fetch(`${API_BASE_URL}/vendors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    signal,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      error: `Failed to create vendor: ${response.status}`,
    }));
    throw new Error(errorData.error);
  }

  return response.json();
}

export async function updateVendor(
  vendorId: string,
  payload: UpdateVendorRequest,
  signal?: AbortSignal
): Promise<Vendor> {
  const response = await fetch(`${API_BASE_URL}/vendors/${vendorId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    signal,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      error: `Failed to update vendor: ${response.status}`,
    }));
    throw new Error(errorData.error);
  }

  const data = await response.json();
  return data.item ?? data;
}
